// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"f866163f","orgContainer":"cb9dbf71","orgRow":"d8f1cc4b","leftCol":"e55cf25a","orgName":"bdc7068b","id":"e3904201","count":"afcd5e5c"};